(function () {
    const isDesignMode = !!(window.Shopify && window.Shopify.designMode);

    function buildTimeline(root) {
      const gsap = window.gsap;
      const product = root.querySelector('[data-ms-product]');
      const pins = root.querySelectorAll('[data-ms-pin]');
      const targets = ['[data-ms-eyebrow]', '[data-ms-heading]', '[data-ms-body]', '[data-ms-cta]']
        .map((s) => root.querySelector(s)).filter(Boolean);

      const tl = gsap.timeline({ defaults: { ease: 'expo.out', duration: 0.9 } });
      if (product) tl.to(product, { opacity: 1, y: 0, scale: 1, duration: 1.1 }, 0);
      if (targets.length) tl.to(targets, { opacity: 1, y: 0, stagger: 0.12, duration: 0.7, ease: 'power3.out' }, 0.4);
      if (pins.length) tl.to(pins, { opacity: 1, stagger: 0.12, duration: 0.5 }, 0.9);
    }

    // Reveal the section. Animates with GSAP if it's loaded; otherwise just
    // makes everything visible (reduced motion, no GSAP, or GSAP not ready).
    function reveal(root) {
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) {
        root.classList.add('animated-showcase--ready');
        return;
      }
      if (typeof window.gsap !== 'undefined') {
        buildTimeline(root);
        return;
      }
      // GSAP not loaded yet when scrolled into view: wait for it, with a
      // fallback so the section is never left stuck hidden.
      let played = false;
      function play() {
        if (played) return;
        played = true;
        document.removeEventListener('gsap:ready', play);
        if (typeof window.gsap !== 'undefined') buildTimeline(root);
        else root.classList.add('animated-showcase--ready');
      }
      document.addEventListener('gsap:ready', play);
      setTimeout(play, 1500);
    }

    function init(root) {
      if (!root || root.dataset.bound === '1') return;
      root.dataset.bound = '1';

      // In the theme editor, scroll triggers are unreliable — reveal now so the
      // merchant always sees the section while editing.
      if (isDesignMode || !('IntersectionObserver' in window)) {
        reveal(root);
        return;
      }

      // Otherwise wait until the section scrolls into view, then play once.
      // Driven by IntersectionObserver (native) so it doesn't depend on GSAP
      // or ScrollTrigger having finished loading at init time.
      const io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            obs.disconnect();
            reveal(root);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
      io.observe(root);
    }

    function initAll() {
      document.querySelectorAll('[data-animated-showcase]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('gsap:ready', initAll);

    // Re-init when Shopify re-renders the section in the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      const root = e.target.querySelector('[data-animated-showcase]');
      if (root) init(root);
    });
  })();
